import { types as t } from 'mobx-state-tree';

export const BidIncrementInterval = t.model('BidIncrementInterval', {
  min_price: t.number,
  max_price: t.number,
  increment: t.number,
});
